/**
 * Block category definitions. Colours are part of the public design system
 * (docs/SPEC.md §3.2) — change them there first, then here.
 */

export type CategoryId =
  | 'control'
  | 'gpio'
  | 'analog'
  | 'interrupts'
  | 'time'
  | 'power'
  | 'comms'
  | 'network'
  | 'servo'
  | 'motor'
  | 'display'
  | 'lan'
  | 'logic'
  | 'math'
  | 'variables'
  | 'text';

export interface CategoryDef {
  id: CategoryId;
  label: string;
  colour: string;
}

export const CATEGORIES: CategoryDef[] = [
  { id: 'control', label: 'Control', colour: '#F08C00' },
  { id: 'gpio', label: 'GPIO', colour: '#2F80ED' },
  { id: 'analog', label: 'Analog & PWM', colour: '#12B0A4' },
  { id: 'interrupts', label: 'Interrupts', colour: '#D64545' },
  { id: 'time', label: 'Time', colour: '#0FA3B1' },
  { id: 'power', label: 'Power', colour: '#34405C' },
  { id: 'comms', label: 'I2C / SPI / UART', colour: '#9B51E0' },
  { id: 'network', label: 'Network', colour: '#3B5BDB' },
  { id: 'servo', label: 'Servo', colour: '#E07A1F' },
  { id: 'motor', label: 'Motor Drivers', colour: '#B58900' },
  { id: 'display', label: 'Displays', colour: '#0B8F6B' },
  { id: 'lan', label: 'Ethernet (LAN)', colour: '#4C6EF5' },
  { id: 'logic', label: 'Logic', colour: '#2EA043' },
  { id: 'math', label: 'Math', colour: '#6E56CF' },
  { id: 'variables', label: 'Variables', colour: '#A87900' },
  { id: 'text', label: 'Text', colour: '#4A5568' },
];

export const CATEGORY_BY_ID: Record<CategoryId, CategoryDef> = Object.fromEntries(
  CATEGORIES.map((c) => [c.id, c]),
) as Record<CategoryId, CategoryDef>;
